// extracted by mini-css-extract-plugin
export default {"main":"ModulesLayout_main__Mufm-"};